import type { FC } from "react";

import { DccProfileSearchForm } from "src/app/features/DccProfile/components/forms/DccProfileSearchForm";
import { DccProfilesTable } from "src/app/features/DccProfile/components/tables/DccProfilesTable";
import type { DccProfileEntity } from "src/app/features/DccProfile/types/DccProfileEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const DccProfilesPage: FC<NoneOwnProps> = () => {
    const table = <DccProfilesTable />;
    const searchForm = <DccProfileSearchForm />;

    return (
        <PageLayout name="dccProfiles_page">
            <PageTitle translationKey="menu.dccProfiles" />
            <ResourceManager<DccProfileEntity>
                useDataGroup
                dataMapperKey="dccProfilesTableData"
                resource={ResourceName.DCC_PROFILES}
                table={table}
                searchForm={searchForm}
                actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
            />
        </PageLayout>
    );
};
